

<banner></banner>
<search ></search>

<div *ngIf="easyRentSection">
    <eazy-rent></eazy-rent>
</div>

<home-middle-content></home-middle-content>
<counters></counters>
<top-deals></top-deals>
<popular-cars [gracePeriodInHours]="gracePeriodInHours"></popular-cars>
<testimonials></testimonials>
<download-app></download-app>
